import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import { bulkDeletePlaylists } from '@disco/state-management/actions/ServerActions'
import DocumentHeadTags from 'components/document-head-tags'
import WarningDialog from 'components/modals/dialogs/warning-dialog'

interface OwnProps {
  params: {
    playlistId: string
  }
  navigate: NavigateFunction
}

const mapDispatchToProps = {
  bulkDeletePlaylists,
}

const connector = connect(null, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & OwnProps

const PlaylistRemoveFromPrivateLibrary = ({
  params: { playlistId },
  bulkDeletePlaylists,
  navigate,
}: Props) => {
  const onClose = () => navigate('/')

  const onConfirm = () => {
    bulkDeletePlaylists([parseInt(playlistId)])
    onClose()
  }

  return (
    <div>
      <DocumentHeadTags title="Delete private playlist | DISCO" />
      <WarningDialog
        confirmButtonCaption="Delete"
        onConfirm={onConfirm}
        onCancel={onClose}
      >
        This is a private playlist that only you can see. If you unstar it, it
        will delete it from your DISCO – it will no longer be available to you
        or the team.
      </WarningDialog>
    </div>
  )
}

const ConnectedPlaylistRemoveFromPrivateLibrary = connector(
  PlaylistRemoveFromPrivateLibrary,
)

function PlaylistRemoveFromPrivateLibraryWithNavigation(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  return (
    <ConnectedPlaylistRemoveFromPrivateLibrary
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}

export default PlaylistRemoveFromPrivateLibraryWithNavigation
